var React = require('react');

function BgQuoteLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.2 13.5c-.8-1-1.2-2.3-1.2-4A9 9 0 0 1 6.8 1L10 3.2C7.2 4.4 5.5 6 4.8 7.8l.2.1a2 2 0 0 1 1.3-.5c.9 0 1.7.4 2.4 1s1 1.5 1 2.7c0 1.2-.3 2.2-1.1 2.9-.8.7-1.8 1-3 1a4 4 0 0 1-3.4-1.5zm11 0c-.8-1-1.2-2.3-1.2-4A9 9 0 0 1 17.8 1L21 3.2c-2.8 1.2-4.5 2.7-5.2 4.6l.2.1a2 2 0 0 1 1.3-.5c.9 0 1.7.4 2.4 1s1 1.5 1 2.7c0 1.2-.3 2.2-1.1 2.9-.8.7-1.8 1-3 1a4 4 0 0 1-3.4-1.5z","stroke":"#e57945","fill":"none","fillRule":"evenodd"}));
}

BgQuoteLeft.defaultProps = {"width":"22","height":"16"};

module.exports = BgQuoteLeft;

BgQuoteLeft.default = BgQuoteLeft;
